module.exports = __webpack_public_path__ + "static/media/oaks-title.59074442.jpg";